import { Tag } from "antd";
import { QCStatus, QCStatusProcess } from "../enum/common";

interface QCStatusConfig {
  color: string;
  text: string;
}

const QC_STATUS_MAP: Record<string, QCStatusConfig> = {
  [QCStatus.PASSED]: {
    color: "green",
    text: "PASSED",
  },
  [QCStatus.REJECT]: {
    color: "red",
    text: "NG",
  },
  [QCStatus.PARTIAL_REJECT]: {
    color: "blue",
    text: "PARTIAL_NG",
  },
  [QCStatus.PROCESSING]: {
    color: "purple",
    text: "PROCESSING",
  },
  [QCStatus.PENDING]: {
    color: "orange",
    text: "PENDING",
  },
};

/**
 * Render QC Status Tag component
 * @param status - QC status string
 * @returns Tag component with appropriate color and text
 */
export const renderQCStatusTag = (status?: string) => {
  const config =
    QC_STATUS_MAP[status || QCStatus.PENDING] ||
    QC_STATUS_MAP[QCStatus.PENDING];

  return (
    <Tag color={config.color} style={{ textTransform: "uppercase" }}>
      {config.text}
    </Tag>
  );
};

/**
 * Get QC Status configuration
 * @param status - QC status string
 * @returns Configuration object with color and text
 */
export const getQCStatusConfig = (status?: string): QCStatusConfig => {
  return (
    QC_STATUS_MAP[status || QCStatus.PENDING] || QC_STATUS_MAP[QCStatus.PENDING]
  );
};
const statusConfig: Record<QCStatusProcess, { color: string; text: string }> = {
  [QCStatusProcess.PENDING]: { color: "orange", text: "Chưa gửi QC" },
  [QCStatusProcess.WAITING]: { color: "gold", text: "Chờ QC lấy hàng" },
  [QCStatusProcess.CHECKING]: { color: "blue", text: "Đang kiểm tra" },
  [QCStatusProcess.COMPLETED]: {
    color: "green",
    text: "Đã hoàn thành kiểm tra",
  },
};

export const getQCProcessStatus = (status: QCStatusProcess) => {
  const config = statusConfig[status];

  return (
    <Tag color={config?.color} key="status">
      {config?.text || "Không xác định"}
    </Tag>
  );
};
